import styled from 'styled-components';

export const ModalContainer = styled.section`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  background-color: rgba(38, 38, 38, 0.54);
`;

export const ModalBody = styled.article`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: ${({ mobileMaxWidth }) => `${mobileMaxWidth}`};
  width: 100%;
  padding: 0 40px;
  padding-top: ${({ noButton }) => noButton ? '25px' : '60px'};
  padding-bottom: 25px;
  
  text-align: center;

  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  overflow: ${({ overflow }) => `${overflow};`};

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  @media (min-width: 768px) {
    max-width: ${({ maxWidth }) => `${maxWidth}`};
  }

  a {
    color: ${({ theme }) => theme.blue};

    transition: color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;

  width: 57px;
  height: 57px;
  margin: 0;
  padding: 0;

  border-radius: 0 0 0 60px;
  background: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
  box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);

  &::after {
    content: "";

    position: absolute;
    top: 18px;
    right: 18px;

    width: 11px;
    height: 11px;

    background: transparent no-repeat center / 11px 11px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='11' fill='none'%3E%3Cpath stroke='%23F4FBFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 10l9-9'/%3E%3Cpath stroke='%23F4FBFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M10 10L1 1l9 9z' clip-rule='evenodd'/%3E%3C/svg%3E");
  }
`;

export const ModalHeading = styled.h2`
  margin: 0;
  margin-bottom: 25px;
  padding: 0;

  font-size: 25px;
  line-height: 1;
  text-align: center;
`;

export const ModalColouredHeading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;

  font-size: 25px;
  line-height: 1;
  text-align: center;
  color: #1eb6ff;
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 210px;
  width: 100%;
  margin-top: 55px;

  button {
    width: 100%;
    
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`;

export const ModalDescription = styled.p`
  
  margin-top: 20px;
  margin-bottom: 35px;
  padding: 0;

  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  text-align: left;

  & + ${ModalButtonContainer} {
    margin-top: 0;
  }
`;
